<template>
  <div v-for="(audit, index) in auditsDataAfficher" v-bind:key="audit.cle" class="row ligne-audit-changement">
    <div class="col text-left">
      <div v-if="index === 0" class="row large-600 bold">Enregistrement courant</div>
      <div v-if="audit.dateChangement" class="row large-600 bold">Informations enregistrées le : {{
          $commun.formatDateHeure(audit.dateChangement)
        }}
      </div>      
      <div v-else class="row large-600 bold">Informations enregistrées le : {{
          $commun.formatDateHeure(vehicule.creerLe)
        }}
      </div>
      <div v-if="audit.changeParEntite" class="row large-600 bold">
        Par : {{ audit.changeParEntite.nomIntervenant?.trim() }}, {{ audit.changeParEntite.prenomIntervenant?.trim() }}, {{ audit.changeParEntite.nomGroupeSecurite?.trim() }}</div>
      <div v-else class="row large-600 erreur bold">
        Intervenant(e) inconnu(e)...</div>

      <div v-for="field in AUDIT_FIELDS" v-bind:key="field" class="row">
        <div class="col-5">{{ FIELD_LABELS[field] }} : </div>
        <div class="col text-center"><div v-if="audit[field].isModifie">{{ this.MODIFIED_ARROW }}</div></div>
        <div class="col">{{ audit[field].texte }}</div>
      </div>
    </div>
  </div>

  <h3>Nombre de modifications : {{ nombreModifications }}</h3>
</template>

<script>
import axios from 'axios';
import { mapGetters } from "vuex";

export default {
  name: "TableModifications",
  emits: ["isDataLoaded", "backendError"],
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$store
      .dispatch("vehicule/obtenirAuditsAction", {
        cle: this.$route.params.cle,
        site: this.$route.params.site,
      })
      .then((res) => {
        this.auditsData = res.data.entite.audits
        if(res.data.entite.audits !== null && res.data.entite.audits.length > 0){
          this.auditsDataAfficher = this.formatterAudits(res.data.entite.audits)
        }else {
          this.auditsDataAfficher = this.formatterAucunAudit();
        }
      })
      .catch((err) => {
        this.$emit("backendError", err);
      })
      .finally(() => {
        this.$emit("isDataLoaded", true);
      });
  },
  data() {
    return {
      auditsData: [],
      auditsDataAfficher: [],
      isDataLoaded: false,
      MODIFIED_ARROW: "🢂",
      AUDIT_FIELDS: [
          "marqueAfficher",
          "modeleAfficher",
          "immatriculation",
          "siteAfficher",
          "provinceAfficher",
          "confidentialiteAfficher",
          "numeroSerie",
          "annee",
      ],
      FIELD_LABELS: {
          "marqueAfficher": "Marque",
          "modeleAfficher": "Modèle",
          "immatriculation": "Immatriculation",
          "siteAfficher": "Site",
          "provinceAfficher": "Province",
          "confidentialiteAfficher": "Confidentialité",
          "numeroSerie": "Numéro de série",
          "annee": "Année",
      },
    };
  },
  computed: {
    ...mapGetters({
        nom: "vehicule/nom",
        jeton: "cardex/jeton",
      profil: 'cardex/profil',
        vehicule: "vehicule/vehicule",
    }),
    nombreModifications() {
      if(this.auditsData.length > 0){
        return this.auditsData.length - 1;
      }else{
        return this.auditsData.length;
      }
    },
    createur() {
      return this.vehicule.creerParDescription
    },
    dateCreation() {
      return this.vehicule.creerLe
    },
  },
  methods: {
    formatterAudits(listeAudits) {
      let listeAffichage = []
      let auditPrecedent = null

      // pour bâtir la diff, il faut revenir en arrière en commençant par
      // l'enregistrement le plus vieux
      listeAudits.sort((a,b) => {
        return new Date(a.dateChangement) - new Date(b.dateChangement)
      });

      // par design, on veut afficher les info actuelles dans le dernier enregistrement.
      // on pousse donc artificiellement un "audit" avec les infos actuelles du vehicule
      listeAudits.push({
          "marqueAfficher": this.vehicule.marqueAfficher,
          "modeleAfficher": this.vehicule.modeleAfficher,
          "immatriculation": this.vehicule.immatriculation,
          "siteAfficher": this.vehicule.siteAfficher,
          "provinceAfficher": this.vehicule.provinceAfficher,
          "confidentialiteAfficher": this.vehicule.confidentialiteAfficher,
          "numeroSerie": this.vehicule.numeroSerie,
          "annee": this.vehicule.annee,
          "changeParEntite": listeAudits[listeAudits.length - 1].changeParEntite,
      })

      listeAudits.forEach((audit, index) => {
        let auditAffichage = {}
        this.AUDIT_FIELDS.forEach(field => {
          auditAffichage[field] = { texte: audit[field], isModifie: false, }
          if (auditPrecedent
            && auditPrecedent[field].texte !== auditAffichage[field].texte) {
              auditAffichage[field].isModifie = true
            }
        })

        // pour l'affichage, il faut comprendre que les entrées de la table
        // d'audits sauvegardent l'information du véhicule _avant_ qu'il ne change.
        // autrement dit, puisqu'on commence avec creerParEntite, les informations suivantes
        // du véhicule sont une date "en retard".
        auditAffichage.changeParEntite = index === 0
          ? this.vehicule.creerParEntite
          : listeAudits[index - 1].changeParEntite

        auditAffichage.dateChangement = index === 0
          ? this.vehicule.creerLe
          : listeAudits[index - 1].dateChangement

        auditPrecedent = auditAffichage

        listeAffichage.push(auditAffichage)
      })

      // par design, la liste est affichée à partir du plus récent enregistrement.
      // pour ne pas désordonner la liste finale, dans le cas vraiment weird où la
      // date de création serait plus avancée que la date du premier audit (e.g. immatriculation MMK9098),
      // on shift() le premier élément avant de filter, puis on le repousse à la fin
      let tmpAuditCreationVehicule = listeAffichage.shift()
      listeAffichage.sort((a,b) => {
        return new Date(b.dateChangement) - new Date(a.dateChangement)
      });
      listeAffichage.push(tmpAuditCreationVehicule)

      return listeAffichage
    },
    formatterAucunAudit(){
      let listeAudits = [];
      let audit = {
          "marqueAfficher": this.vehicule.marqueAfficher,
          "modeleAfficher": this.vehicule.modeleAfficher,
          "immatriculation": this.vehicule.immatriculation,
          "siteAfficher": this.vehicule.siteAfficher,
          "provinceAfficher": this.vehicule.provinceAfficher,
          "confidentialiteAfficher": this.vehicule.confidentialiteAfficher,
          "numeroSerie": this.vehicule.numeroSerie,
          "annee": this.vehicule.annee,
          "changeParEntite": this.vehicule.creerParEntite
      }
      let auditAffichage = {}
      this.AUDIT_FIELDS.forEach(field => {
        auditAffichage[field] = { texte: audit[field], isModifie: false, }
      })

      auditAffichage.changeParEntite = audit.changeParEntite

      listeAudits.push(auditAffichage);
      return listeAudits;
    }
  },
};
</script>
